import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Props {
  last4: string;
  onSuccess?: () => void;
  onError?: () => void;
}

const useVerifyCard = ({ last4, onSuccess, onError }: Props) => {
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    () => api.patch(API_URL.CARDS_VERIFY, null, { params: { last4 } }),
    {
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: () => {
        if (onError) {
          onError();
        }
      },
    }
  );

  return {
    onVerify: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useVerifyCard;
